import React from 'react';
import Styles from './Home.module.scss';
import classnames from "classnames";
import imageLink from "../../images/smooth_profile.png";


interface HomeProps {
    theme: string;
    backgroundImageUrl: string;
}
const Home = ({ theme, backgroundImageUrl }: HomeProps) => {

    return (
                <div className={Styles.quote}>
                    <h3 className={Styles.quote_text}>
                        {/* There are no rules for good photographs,
                        <br />There are only good photographs. */}
                        It’s one thing to make a picture of what a person looks like, it’s another thing to make a portrait of who they are.
                    </h3>
                    {/* <div className={Styles.by}>- Ansel Adams</div> */}
                    <div className={Styles.by}>— Paul Caponigro</div>
                </div>

    )
}

export default Home

